import { createContext } from 'react'

import { SelectObj } from './interfaces'

export const initialState: SelectObj = { selectedItem: null, mode: 'single' }

export const SelectContext = createContext<{
  state: SelectObj
  dispatch: React.Dispatch<any>
}>({
  state: initialState,
  dispatch: () => null,
})
